import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Region Code Management Service
 * !== 지역 코드 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/comnmdle/regncd`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/comnmdle/regn-cd`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Code Management" }],
};

export const URLS = {
    ptli0415001q: `${BASE.path}/ptli0415001q`, // Region Code Management List !== 지역 코드 관리 목록 ==!
    ptli0415002s: `${BASE.path}/ptli0415002s`, // Region Code Registration !== 지역 코드 등록 ==!
    ptli0415003s: `${BASE.path}/ptli0415003s`, // Region Code Modification !== 지역 코드 수정 ==!
};

export const APIS = {
    // Retrieve a list of region codes. !== 지역코드 목록을 조회한다.==!
    getRegnCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Retrieve region code information. !== 지역코드 정보를 조회한다.==!
    getRegnCdInfo: (regnCd: any) => api.get(`${BASE.api}/${regnCd}`),

    // Save region code information !== 지역코드 정보 저장 ==!
    insertRegnCdInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Modify region code information !== 지역코드 정보 수정 ==!
    updateRegnCdInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    deleteRegnCdInfo: (regnCd: any) => api.delete(`${BASE.api}/${regnCd}`),
};

// Region Code Management Search Form !== 지역 코드 관리 검색 폼 ==!
export const SF_REGN_CD_SRCH: TFormSchema = {
    id: "form_regnCdSrch",
    schema: {
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd" },
        regnTpCd: { type: "select", label: "L_REGN_TP_CD", area: "comnCd", comnCd: "COM0033" },
        regnCd: { type: "text", label: "L_REGN_CD", letterCase: "upper" },
        regnNm: { type: "text", label: "L_REGN_NM" },
    },
};

// Region Code Management List Grid Schema !== 지역 코드 관리 목록 그리드 스키마 ==!
export const SG_REGN_CD_LIST: TGridSchema = {
    id: "grid_regnCdList",
    options: { pagination: "out", index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_REGN_CD", binding: "regnCd", width: "15%" }] },
        { cells: [{ header: "L_REGN_TP_CD_NM", binding: "regnTpCdNm", width: "15%" }] },
        { cells: [{ header: "L_REGN_NM", binding: "regnNm", width: "*" }] },
        { cells: [{ header: "L_CNTY_NM", binding: "cntyNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "regnCd", edit: false }] },
        { cells: [{ binding: "regnTpCdNm", edit: false }] },
        { cells: [{ binding: "regnNm", edit: false, align: "left" }] },
        { cells: [{ binding: "cntyNm", edit: false, align: "left" }] },
    ],
};

// Region Code Management Form !== 지역 코드 관리 폼 ==!
export const SF_REGN_CD_INFO: TFormSchema = {
    id: "form_regnCdInfo",
    schema: {
        regnCd: {
            type: "text",
            label: "L_REGN_CD",
            required: true,
            maxLength: 5,
            letterCase: "upper",
        },
        regnTpCd: {
            type: "select",
            label: "L_REGN_TP_CD",
            required: true,
            all: true,
            area: "comnCd",
            comnCd: "COM0033",
        },
        cstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_CD",
        },
        portYn: {
            type: "select",
            area: "comnCd",
            comnCd: "COM0064",
            label: "L_PORT_YN",
        },
        cntyCd: { type: "code", label: "L_CNTY_CD", required: true, area: "cntyCd" },
        regnNmEn: { type: "text", label: "English", required: true, maxLength: 200 },
        regnNmKo: { type: "text", label: "Korean" },
        regnNmTz: { type: "text", label: "Kiswahili" },
        
    },
};
